import { defineStore } from 'pinia'
import { UserV2Service } from '@/services/user-v2-service'
import axios from 'axios'
import { ref } from 'vue'
import type { ApiError } from '@/utils/types'
import { FALLBACK_API_ERROR } from '@/utils/consts'
import type { UserSettingsUpdate, UserSignalRequest } from '@/services/user-v2-service/types'
import md5 from 'md5'

type ActionFlags = 'refUrls' | 'save'
export const useUserStore = defineStore('user', () => {
  const loading = ref<Partial<Record<ActionFlags, boolean>>>({})
  const error = ref<Partial<Record<ActionFlags, ApiError>>>({})

  const getRefUrls = async (agent: string) => {
    loading.value.refUrls = true
    try {
      const req = await UserV2Service.getRefUrls(agent)
      return req.data
    } catch (thrown) {
      if (axios.isAxiosError(thrown) && thrown.response) {
        error.value.refUrls = {
          message: thrown.response?.data,
          code: thrown.response?.status,
        }
      } else {
        error.value.refUrls = FALLBACK_API_ERROR
      }
    } finally {
      loading.value.refUrls = false
    }
  }

  const saveUserSettings = async (data: UserSettingsUpdate) => {
    loading.value.save = true
    try {
      const req = await UserV2Service.saveUserSettings(data)
      return req.data
    } catch (thrown) {
      if (axios.isAxiosError(thrown) && thrown.response) {
        error.value.save = {
          message: thrown.response?.data,
          code: thrown.response?.status,
        }
      } else {
        error.value.save = FALLBACK_API_ERROR
      }
    } finally {
      loading.value.save = false
    }
  }

  const sendSignal = async (message: string) => {
    const hashed = md5(`some_salt${message}`).toLowerCase()
    const data = {
      content: message,
      hash: hashed,
    } as UserSignalRequest
    return await UserV2Service.sendUserSignal(data)
  }

  return {
    saveUserSettings,
    getRefUrls,
    loading,
    error,
    sendSignal,
  }
})
